if (!customElements.get('np-shipping-strip')) {
  customElements.define('np-shipping-strip', class extends HTMLElement {
    static get observedAttributes() { return ['data-total']; }
    attributeChangedCallback() { if (this.isConnected && this.fmt) this.schedule(); }
    connectedCallback() { this.schedule(); }
    schedule() {
      // Wait for the theme to finish morphing the drawer's children before drawing.
      clearTimeout(this._t);
      this._t = setTimeout(() => this.update(), 30);
    }
    money(n) {
      // Matches the cart: $339.00 AUD (decimals follow the local currency, e.g. none for JPY)
      return this.dataset.symbol + this.fmt.format(n) + ' ' + this.dataset.currency;
    }
    update() {
      const d = this.dataset;
      // Decimal places the local currency normally uses (2 for AUD, 0 for JPY, etc.)
      let digits = 2;
      try { digits = new Intl.NumberFormat('en', { style: 'currency', currency: d.currency }).resolvedOptions().maximumFractionDigits; } catch (e) {}
      this.fmt = new Intl.NumberFormat('en-AU', { minimumFractionDigits: digits, maximumFractionDigits: digits });

      const rate = (window.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;
      const converted = d.convert === 'true' && rate !== 1;
      // Converted AUD amounts are rounded up to a whole local unit so they read cleanly.
      const conv = n => converted ? Math.ceil(n * rate) : n;
      this.mode = d.mode;
      this.threshold = conv(+d.threshold);
      this.flat = conv(+d.flat);
      this.total = +d.total;
      const flatEl = this.querySelector('[data-flat-label]');
      if (flatEl) flatEl.textContent = this.money(this.flat);

      const KEY = 'np-ship-last';
      let last = 0;
      try { last = +(sessionStorage.getItem(KEY) || 0); sessionStorage.setItem(KEY, this.total); } catch (e) {}

      const goal = this.mode === 'duties' ? null : this.threshold;
      const increased = this.total > last;
      const wasBelow = goal === null ? last === 0 : last < goal;
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

      cancelAnimationFrame(this._raf);
      if (increased && wasBelow && !reduce) this.animate(last, this.total);
      else this.render(this.total, 1, true);
    }
    render(v, t, done) {
      const num = this.querySelector('[data-num]');
      if (!num) return;
      num.textContent = this.fmt.format(v);
      const fill = this.querySelector('.np-ship__fill');
      const rem = this.querySelector('[data-remaining]');
      let won;
      if (this.mode === 'duties') {
        fill.style.width = t * 100 + '%';
        won = done;
        this.querySelectorAll('.np-ship__node').forEach(n => n.classList.toggle('is-hit', t > 0 && t >= +n.dataset.at - 0.001));
      } else {
        fill.style.width = Math.min(v / this.threshold, 1) * 100 + '%';
        won = v >= this.threshold;
        if (rem) rem.textContent = this.money(Math.max(this.threshold - v, 0));
        this.querySelector('.np-ship__node--end').classList.toggle('is-hit', won);
      }
      this.classList.toggle('is-won', won);
    }
    animate(from, to) {
      const DUR = 1400, ease = t => 1 - Math.pow(1 - t, 3);
      this.render(from, 0, false);
      const start = performance.now() + 250;
      const step = now => {
        const t = Math.max(0, Math.min((now - start) / DUR, 1));
        const e = ease(t);
        this.render(from + (to - from) * e, e, t >= 1);
        if (t < 1) this._raf = requestAnimationFrame(step);
      };
      this._raf = requestAnimationFrame(step);
    }
  });
}
